/* RESPONSIBLE TEAM: team-proactive-support */
import GlobalLoadingRoute from 'embercom/routes/base/global-loading-route';

export default GlobalLoadingRoute.extend();
